"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeightJson = exports.Weight = exports.WeightUnitTexts = exports.WeightUnits = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const Quantity_1 = require("./Quantity");
var WeightUnits;
(function (WeightUnits) {
    WeightUnits["norm"] = "g";
    WeightUnits["kg"] = "kg";
    WeightUnits["g"] = "g";
    WeightUnits["oz"] = "oz";
    WeightUnits["lb"] = "lb";
})(WeightUnits = exports.WeightUnits || (exports.WeightUnits = {}));
exports.WeightUnitTexts = {
    [WeightUnits.norm]: 'g',
    [WeightUnits.kg]: 'kg',
    [WeightUnits.g]: 'g',
    [WeightUnits.oz]: 'oz',
    [WeightUnits.lb]: 'lb',
};
class Weight extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'Weight';
        this.defaultUnit = 'g';
        this.unitTexts = exports.WeightUnitTexts;
    }
    static getUnitText(unit) {
        return exports.WeightUnitTexts[unit];
    }
    static fromJson(q) {
        if (!Object.values(WeightUnits).includes(q.Unit)) {
            throw new Error(`Weight.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new Weight(q);
    }
    static kg(v) {
        return new Weight(v, WeightUnits.kg);
    }
    static g(v) {
        return new Weight(v, WeightUnits.g);
    }
    static oz(v) {
        return new Weight(v, WeightUnits.oz);
    }
    static lb(v) {
        return new Weight(v, WeightUnits.lb);
    }
    set kg(v) {
        this.value = v;
        this.unit = WeightUnits.kg;
    }
    get kg() {
        return this.unit === WeightUnits.kg ? this.value : this.g / 1000;
    }
    set g(v) {
        this.value = v;
        this.unit = WeightUnits.g;
    }
    get g() {
        switch (this.unit) {
            case WeightUnits.kg:
                return this.value * 1000;
            case WeightUnits.g:
                return this.value;
            case WeightUnits.oz:
                return this.value / 0.035274;
            case WeightUnits.lb:
                return this.value / 0.002204622621849;
        }
        throw new Error(`${this.className}.g: unknown unit ${this.unit}`);
    }
    set oz(v) {
        this.value = v;
        this.unit = WeightUnits.oz;
    }
    get oz() {
        return this.unit === WeightUnits.oz ? this.value : this.g * 0.035274;
    }
    set lb(v) {
        this.value = v;
        this.unit = WeightUnits.lb;
    }
    get lb() {
        return this.unit === WeightUnits.lb ? this.value : this.g * 0.002204622621849;
    }
    clone() {
        return Weight.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case WeightUnits.g:
                return this.g;
            case WeightUnits.kg:
                return this.kg;
            case WeightUnits.oz:
                return this.oz;
            case WeightUnits.lb:
                return this.lb;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
        throw new Error(`${this.className}.getValue: Unit not supported: ${unit}`);
    }
}
exports.Weight = Weight;
Weight.units = WeightUnits;
const isWeightJson = (l) => {
    return (0, Quantity_1.isQuantityJson)(l) && (0, echain_shared_ts_utils_1.isValueInEnum)(WeightUnits, l.Unit);
};
exports.isWeightJson = isWeightJson;
//# sourceMappingURL=Weight.js.map